import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function Terms() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12">
      <h1 className="mb-6 text-4xl font-semibold tracking-tight">Terms of Use</h1>
      <Card>
        <CardHeader>
          <CardTitle>What Heuristic Hero does with your submission</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm">
          <p>
            <strong>Permission.</strong> Only submit URLs you own or have permission to test. By submitting, you
            authorize Heuristic Hero to fetch the page using a headless browser and run accessibility scans against it.
          </p>
          <p>
            <strong>Data retained.</strong> The URL you submit, the score, the cost, and the model used are recorded
            in our evaluation corpus and kept indefinitely so that we can show comparative percentile rankings.
            <strong> Your DESIGN.md content, screenshots, and raw scanner outputs are stored in private blob storage
            for 90 days, then deleted automatically.</strong>
          </p>
          <p>
            <strong>Privacy.</strong> The corpus stores URL + scores + cost only. No DESIGN.md content, no source
            code, no screenshots, no PII.
          </p>
          <p>
            <strong>Rate limits.</strong> Submissions are limited per IP to keep the platform usable for everyone. A
            daily spend cap protects against runaway cost.
          </p>
          <p>
            <strong>Trust.</strong> Heuristic Hero scores your site automatically. Use the output as a starting
            point for further evaluation, not as a final judgment. Manual review by a human always wins.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
